<template>
  <div>
    <van-sticky :offset-top="46" @scroll="handleScrollStatus">
      <van-search
        v-model="queryParams.productName"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
      <van-dropdown-menu>
        <van-dropdown-item v-model="queryParams.purchaseStatus" :options="option" @change="handleRefresh"/>
        <van-dropdown-item title="筛选" ref="item">
          <van-cell title="配送日期" :value="queryParams.deliveryDate" @click="show = true" />
<!--          <div style="padding: 5px 16px;">-->
<!--            <van-button type="danger" block round @click="() => { this.$refs.item.toggle(); handleRefresh()}">-->
<!--              确认-->
<!--            </van-button>-->
<!--          </div>-->
        </van-dropdown-item>
      </van-dropdown-menu>
    </van-sticky>
    <van-row>
      <van-col span ='24'>
        <van-cell style="border-radius: 6px">
          <template #default>
            <van-row style="background-color:rgba(49,175,237,0.82);line-height: 32px;border-radius: 6px;padding: 6px 10px">
              <van-col span="18">采购成本: <span style="font-size: 18px;font-weight: 500">{{statistics.purchaseTotalAmount}}</span></van-col>
              <van-col span="6">{{statistics.deliveryDate}}</van-col>
              <van-col span="12">已采购: {{statistics.confirmPurchaseQuantity}} 件</van-col>
              <van-col span="12" align="right">待采购: <span class="loss" style="font-size: 18px">{{statistics.waitPurchaseQuantity}}</span> 件</van-col>
            </van-row>
          </template>
        </van-cell>
      </van-col>
    </van-row>
    <page-list ref='pageList' request-url="/purchase" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="18">商家名称: {{row.supplierName}}</van-col>
          <van-col span="6">{{row.deliveryDate}}</van-col>
          <van-col span="24">商品名称: {{row.productName}}</van-col>
          <van-col span="18">商品分类: {{row.categoryCode}}</van-col>
          <van-col span="6"><van-tag v-if = "row.purchaseStatus === 1" type="success">已采购</van-tag><van-tag v-else >待采购</van-tag></van-col>
          <van-col span="12">销售单价: {{row.price}}</van-col>
          <van-col span="12">销售数量: {{row.quantity +' ' +row.unit}}</van-col>
          <van-col span="12">采购单价: <span :class="row.purchasePrice > row.price?'loss': (row.purchasePrice > row.supplierPrice?'warn':(row.purchasePrice < row.supplierPrice?'profit':''))">{{row.purchasePrice}}</span></van-col>
          <van-col span="12">采购数量: <span :class="row.purchaseQuantity > row.quantity?'loss':(row.purchaseQuantity < row.quantity? 'profit':'')"> {{row.purchaseQuantity +' ' +row.unit}}</span></van-col>
          <van-col span="12">结算单价: {{row.supplierPrice}}</van-col>
          <van-col span ='24'>
            <van-cell style="border-radius: 6px">
              <template #title>
                <div style="line-height: 32px;font-weight: 500;font-size: 16px">成本: <span style="font-size: 20px" :class="row.purchasePrice > row.price?'loss': (row.purchasePrice > row.supplierPrice?'warn':(row.purchasePrice < row.supplierPrice?'profit':''))">{{row.purchaseAmount}}</span></div>
              </template>
              <template #default>
                <van-button type="info" size="small" style="padding: 0px 12px;font-size: 16px;border-radius: 6px" @click="openAdjustPurchase(row)" >调整</van-button>
              </template>
            </van-cell>
          </van-col>
        </van-row>
      </template>
    </page-list>
    <down-drawer ref='purchaseDrawer' @close="handleRefresh" @confirm="adjustPurchaseInfo" title="调整采购信息" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            name="purchasePrice"
            label="采购单价"
            input-align ='right'
            :rules="[{ required: true, message: '采购单价不能为空' }]">
            <template #input>
              <van-stepper v-model="model.purchasePrice" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
          <van-field
            name="purchaseQuantity"
            label="采购数量"
            input-align ='right'
            :rules="[{ required: true, message: '采购数量不能为空' }]">
            <template #input>
              <van-stepper v-model="model.purchaseQuantity" step="0.1" :decimal-length="2" :input-width ='64' :min="0"/>
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
    <van-calendar v-model="show" :show-confirm="false" @confirm="onDeliveryDateConfirm" :min-date="minDate" :style="{ height: '500px' }"/>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'PurchaseList',
  components: { PageList },
  created () {
    this.queryParams.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.statistics.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    // 获取当前配送日期的采购信息
    this.getPurchaseStatistics()
  },
  data () {
    const that = this
    return {
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      purchaseVisible: false,
      show: false,
      allOrder: false,
      model: {},
      queryParams: {
        purchaseStatus: -1,
        deliveryDate: '',
        productName: null

      },
      statistics: {
        deliveryDate: '',
        purchaseTotalAmount: 0.00,
        waitPurchaseQuantity: 0,
        confirmPurchaseQuantity: 0
      },
      minDate: new Date(that.$moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')),
      option: [
        { text: '全部采购单', value: -1 },
        { text: '待采购', value: 0 },
        { text: '已采购', value: 1 }
      ]
    }
  },
  computed: {

  },
  methods: {
    openAdjustPurchase (row) {
      this.model = {}
      this.$refs.purchaseDrawer.show = true
      this.model.purchaseId = row.id
      this.model.purchasePrice = row.purchasePrice
      this.model.purchaseQuantity = row.purchaseQuantity
    },
    adjustPurchaseInfo () {
      if (!this.model.purchasePrice || isNaN(this.model.purchasePrice)) {
        this.$toast.fail('无效的采购单价')
        return
      }
      if (!this.model.purchaseQuantity || isNaN(this.model.purchaseQuantity)) {
        this.$toast.fail('无效的采购数量')
        return
      }
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.shop.updatePurchaseInfo(this.model.purchaseId, {
          purchasePrice: this.model.purchasePrice,
          purchaseQuantity: this.model.purchaseQuantity
        }).then(response => {
          if (response.success) {
            this.$toast.success('操作成功')
            this.$refs.purchaseDrawer.show = false
          } else {
            this.$toast.fail(response.message)
          }
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      if (this.queryParams.purchaseStatus !== -1) {
        param.purchaseStatus = this.queryParams.purchaseStatus
      }
      param.deliveryDate = this.queryParams.deliveryDate
      param.productName = this.queryParams.productName
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
      // 获取当前配送日期的采购信息
      this.getPurchaseStatistics()
    },
    getPurchaseStatistics () {
      this.$api.shop.getPurchaseStatistics(this.queryParams.deliveryDate).then(response => {
        if (response.success) {
          this.statistics = response.result
        }
      }).catch(() => {
      })
    },
    onDeliveryDateConfirm (date) {
      this.show = false
      this.queryParams.deliveryDate = this.$moment(date).format('YYYY-MM-DD')
      this.$refs.item.toggle()
      this.handleRefresh()
    },
    handleScrollStatus (e) {
      // console.log(JSON.stringify(e))
      // if (e.isFixed === false) {
      //   this.$toast.success(JSON.stringify(e))
      // }
    }

  }
}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
